import axios, { AxiosError } from 'axios';
import { isStatusCodeGroup } from 'utils/api/error/ResponseError';
import { provider as SentryProvider } from 'utils/integrations/Sentry';
import { Nullable } from 'utils/types';

const apiClient = axios.create({});

let authToken: string | null = null;

if (process.env.REACT_APP_API_URL) {
  apiClient.defaults.baseURL = process.env.REACT_APP_API_URL;
}

const setHeaders = (config: any) => {
  const editedConfig = config;
  if (authToken) {
    editedConfig.headers['X-Access-Token'] = `Bearer ${authToken}`;
  }
  return editedConfig;
};

apiClient.interceptors.request.use(setHeaders);
apiClient.interceptors.response.use(undefined, (error: AxiosError) => {
  if (error.response && !isStatusCodeGroup(error.response, '4xx')) {
    SentryProvider.getSentry().captureException(error);
  }

  return Promise.reject(error);
});

export const setAuthToken = (token: Nullable<string>) => {
  authToken = token;
};

type Cached = { [key: string]: { value: any; timeStamp: number } };

let cached: Cached = {};

export const cachedRequest = async <TReturnType>(cb: any, key: any): Promise<TReturnType> => {
  const currentTime = new Date().getTime();

  if (Object.keys(cached).includes(key) && currentTime - cached[key].timeStamp <= 120 * 1000) {
    return cached[key].value as TReturnType;
  }

  const value = await cb();
  cached[key] = { value, timeStamp: currentTime };
  return value;
};

export default apiClient;
